<template>
    <table class="calculationTable">
        <tr>
            <th>{{headers.header}}</th>
            <th>{{headers.header_value}}</th>
            <th>%</th>
        </tr>
        <tr v-for="item in values" :key="item.name">
            <td>{{item.name}}</td>
            <td>{{item.value | money}}</td>
            <td>{{percentage(item.value)}}</td>
        </tr>
        <tr class="total">
            <td>{{headers.footer}}</td>
            <td>{{ total | money }}</td>
            <td>100%</td>
        </tr>
    </table>
</template>
<script>
    export default {
        props: {
            values: Array,
            headers: Array
        },

        filters: {
            money(value) {
                return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format((value));
            },
        },

        computed: {
            total() {
                let total = 0;
                for(let i = 0; i < this.values.length; i++) {
                    total = parseInt(total) + parseInt(this.values[i].value);
                }

                return total;
            }
        },

        methods: {
            percentage(value) {
                 let total = 0;
                for(let i = 0; i < this.values.length; i++) {
                    total = parseInt(total) + parseInt(this.values[i].value);
                }

                value = value/total*100;
                
                return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((value)) + '%';
            }
        }
    }
</script>
